<template>
  <v-main>
    <v-container>
      <v-card elevation="6">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Update {{ form.type | capitalize }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                style="margin-top: 9px"
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-ferry"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="form.type == 'PROJECT'">
              <v-row style="padding-top: 32px">
                <v-col md="3">
                  <label for="">Document</label>
                </v-col>
                <v-col md="9">
                  <input
                    type="file"
                    id="file"
                    name="file"
                    ref="file"
                    multiple
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="4" v-if="form.type == 'PROJECT'">
              <v-row style="padding-top: 32px">
                <v-col md="3">
                  <label for="">Logo</label>
                </v-col>
                <v-col md="9">
                  <input type="file" id="logo" name="logo" ref="logo" />
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="4" v-if="form.type == 'TEMPLATE'">
              <v-textarea
                v-model="form.term_condition"
                outlined
                hide-details="auto"
                class="mb-0"
                rows="2"
                label="Term & Consition"
                clearable
                clear-icon="mdi-close-circle"
              ></v-textarea>
            </v-col>
            <v-col sm="4" v-if="form.type == 'PROJECT'">
              <v-textarea
                v-model="form.signature"
                outlined
                prepend-inner-icon="mdi-draw"
                hide-details="auto"
                class="mb-0"
                rows="1"
                label="Signature"
                clearable
                clear-icon="mdi-close-circle"
                dense
              ></v-textarea>
            </v-col>
            <v-col sm="4" v-if="form.type == 'PROJECT'">
              <v-menu
                v-model="form.estimated_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Select Estimate Date"
                    v-model="form.estimated_date"
                    :id="`estimated_date`"
                    readonly
                    prepend-inner-icon="mdi-calendar-range"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    hide-details="auto"
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  :id="`estimated_date`"
                  v-model="form.estimated_date"
                  @change="form.estimated_date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- <v-col sm="4" v-if="form.type == 'PROJECT'">
              <v-select
                v-model="form.port_id"
                prepend-inner-icon="mdi-ferry"
                :items="portItems"
                outlined
                label="Port"
                dense
                hide-details="auto"
              >
              </v-select>
            </v-col> -->
            <v-col sm="4">
              <v-switch
                v-model="form.status"
                inset
                :label="`Is Active: ${
                  form.status.toString() == 'true' ? 'YES' : 'NO'
                }`"
              ></v-switch>
            </v-col>
          </v-row>
          <br />
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn
            v-else
            color="primary"
            dark
            @click="save"
            :disabled="form.created_by_id != user.id && roleName == 'Handler'"
          >
            Update {{ form.type }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ProjectEditPage",
  data() {
    return {
      form: {
        name: "",
        status: false,
      },
      isLoading: false,
      portItems: [{ id: 0, text: "Select Port", value: "0" }],
    };
  },
  mounted() {
    this.form.type = this.$route.query.type
      ? this.$route.query.type
      : "PROJECT";
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(`projects/masters`);
      masters = masters.data;

      masters.ports.forEach((port) => {
        this.portItems.push({
          id: port.id,
          text: port.description,
          value: port.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/projects/${this.$route.params.projectId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post(`/projects`, this.form);
        this.isLoading = false;
        this.$router.push(
          `/${this.form.type.toLowerCase()}s?type=${this.form.type}`
        );
        this.handleFileUpload();
        this.handleLogoUpload();
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let list = this.$refs.file.files;
        let formData = new FormData();
        formData.append("project_id", this.form.id);
        let attachment_count = 0;
        list.forEach((att, i) => {
          let attachment_name = "documentpath_" + i;

          let attachment = this.$refs.file.files[i];
          formData.append(attachment_name, attachment);
          attachment_count++;
        });
        formData.append("attachment_count", attachment_count);
        await axios
          .post("upload_project_documents", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function () {
            console.log("FAILURE!!");
          });
      }
    },
    async handleLogoUpload() {
      this.logo = this.$refs.logo.files[0];
      console.log(this.logo);
      let formData = new FormData();
      formData.append("project_id", this.form.id);
      formData.append("logo", this.logo);
      await axios
        .post("upload_logo_project", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
